import routes from './routes'
import {
  render,
  unmountComponentAtNode
} from 'react-dom'
import React from 'react'
import {parseUrl, onError} from 'util'
import animate from 'util/animate'
import loading from 'util/loading'
import store from 'store'
import {hasAdminPermission, permissionsForAdmin} from 'util/admin-permissions'

const DELTA = 34

const ROUTE_PERMISSIONS = {
  '/': 'dashboard.read',
  '/material/home': 'content.manage',
  '/material/home/add': 'content.manage',
  '/material/faq': 'content.manage',
  '/material/faq/add': 'content.manage',
  '/tools/card-batch': 'card.manage',
  '/tools/card-assets': 'card.read',
  '/users': 'user.read'
}

function canOpenRoute(path) {
  const user = store.user
  if (!user) return false
  if (path === '/users/admin') return !!user.isSuperAdmin
  const permission = ROUTE_PERMISSIONS[path]
  return !permission || hasAdminPermission(user, permission)
}

const PAGE_META = {
  '/': {
    title: '运营工作台',
    desc: '按日常运营、内容维护、投放生产和权限管理组织后台任务。'
  },
  '/material/home': {
    title: '首页音频',
    desc: '维护小程序首页可播放的音频内容。'
  },
  '/material/home/add': {
    title: '编辑首页音频',
    desc: '新增或调整首页展示音频。'
  },
  '/material/faq': {
    title: '常见问题',
    desc: '维护用户在小程序内看到的帮助问答。'
  },
  '/material/faq/add': {
    title: '编辑常见问题',
    desc: '新增或调整问题与答案。'
  },
  '/tools/card-batch': {
    title: '录音卡生产',
    desc: '上传背景图，调整唱片与小程序码位置，批量生成可独立录音的投放卡。'
  },
  '/tools/card-assets': {
    title: '\u97f3\u9891\u4e0e\u97f3\u4fe1\u5361',
    desc: '\u67e5\u770b\u5df2\u751f\u6210\u7684\u97f3\u4fe1\u5361\u3001\u5f55\u97f3\u72b6\u6001\u3001\u97f3\u9891\u4e0b\u8f7d\u94fe\u63a5\u548c\u97f3\u4fe1\u7801\u94fe\u63a5\u3002'
  },
  '/users/admin': {
    title: '管理员审批',
    desc: '处理后台管理员申请与权限状态。'
  },
  '/users': {
    title: '全部用户',
    desc: '查看小程序用户资料和账号状态。'
  }
}

function pageClass(path) {
  return `page-${path.replace(/^\//, '').replace(/\//g, '-') || 'home'}`
}

function createPageHeader(meta) {
  let header = document.createElement('section')
  header.className = 'page-header'

  let copy = document.createElement('div')
  copy.className = 'page-header-copy'

  let eyebrow = document.createElement('span')
  eyebrow.className = 'page-eyebrow'
  eyebrow.textContent = '音信后台'

  let title = document.createElement('h1')
  title.textContent = meta.title

  let desc = document.createElement('p')
  desc.textContent = meta.desc

  copy.appendChild(eyebrow)
  copy.appendChild(title)
  copy.appendChild(desc)
  header.appendChild(copy)

  return header
}

export default class Page {
  constructor(url) {
    this.parentNode = document.querySelector('.main')
    this.url = url
    let {path, query} = parseUrl(url)
    this.path = path
    this.query = query

    this.el = document.createElement('div')
    this.el.className = `page ${pageClass(path)}`
    this.shell = document.createElement('div')
    this.shell.className = 'page-shell'
    this.body = document.createElement('div')
    this.body.className = 'page-body'
    this.shell.appendChild(createPageHeader(PAGE_META[path] || {
      title: '后台页面',
      desc: ''
    }))
    this.shell.appendChild(this.body)
    this.el.appendChild(this.shell)
    this.parentNode.appendChild(this.el)

    let fn = routes[path]
    if (!fn) throw new Error('Module not found for ' + path)
    if (!canOpenRoute(path)) {
      let denied = document.createElement('div')
      denied.className = 'page-access-denied'
      denied.setAttribute('role', 'alert')
      denied.textContent = '当前账号没有访问此页面的权限。请从左侧选择可用功能。'
      this.body.appendChild(denied)
      return
    }
    let hide = loading({title: '页面加载中...'})
    fn().then(module => {
      hide()
      setTimeout(() => {
        let Clz = module.default
        let current = React.createElement(Clz, {
          path: path,
          query: query,
          permissions: permissionsForAdmin(store.user)
        })
        render(current, this.body)
        this.mounted = true
      }, 20)
    }, e => {
      hide()
      onError(new Error('页面加载失败，请刷新重试'))
    })
  }
  switchIn(isBack = false) {
    if (this.promise) this.promise.stop()
    let {el} = this
    el.style.display = 'block'
    el.style.zIndex = isBack ? -1 : 1
    let promise = animate(el, {
      from: {
        x: isBack ? -DELTA : DELTA,
        opacity: 0
      },
      to: {
        x: 0,
        opacity: 1
      },
      ease: 'out-cubic'
    })
    promise.then(stopped => {
      if (!stopped) {
        el.style.zIndex = 1
      }
    })
    this.promise = promise
  }
  switchOut(isBack = false, remove) {
    if (this.promise) this.promise.stop()
    this.promise = null
    let {el} = this
    el.style.display = 'none'
    if (remove) this.remove()
  }
  remove() {
    if (this._removed) return
    this._removed = true
    if (this.mounted) unmountComponentAtNode(this.body)
    this.parentNode.removeChild(this.el)
  }
}
